module.exports = __webpack_public_path__ + "img/icon-carousel-arrow-left.b8e1ae79.svg";